// extracted by mini-css-extract-plugin
module.exports = {"audioButton":"AudioButton_audioButton__1w9sY"};